export default "__VITE_ASSET__21c461a4__"